import clsx from 'clsx';

export enum ColorsEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  SecondaryLight = 'secondary-light',
  White = 'white',
  Black = 'black',
  Gray = 'gray',
  Gothic = 'gothic',
  Green = 'green',
  Red = 'red',
}
interface ITypography {
  className?: string;
  size?:
    | 'xs' // 12px
    | 'sm' // 14px
    | 'lg' // 18px
    | 'xl' // 20px
    | '2xl' // 24px
    | '3xl' // 30px
    | '4xl' // 36px
    | '5xl' // 48px
    | '6xl' // 60px
    | '7xl' // 72px
    | '8xl' // 96px
    | '9xl'; // 128px
  weight?:
    | 'light' // 300
    | 'medium' // 500
    | 'semibold' // 600
    | 'bold'; // 700
  color?: ColorsEnum;
  isUppercase?: boolean;
  children?: React.ReactNode;
}

export const Text = (props: ITypography) => {
  const className = clsx(
    `font-${props.weight || 'normal'}`,
    props.size && `text-${props.size}`,
    !props.color && 'text-soft-black dark:text-white',
    props.color === ColorsEnum.Primary && 'text-primary',
    props.color === ColorsEnum.Secondary && 'text-slate dark:text-gray-dark',
    props.color === ColorsEnum.SecondaryLight && 'text-light-gray dark:text-gray-white',
    props.color === ColorsEnum.White && 'text-white',
    props.color === ColorsEnum.Black && 'text-soft-black',
    props.color === ColorsEnum.Gray && 'text-pearl-dark-gray',
    props.color === ColorsEnum.Gothic && 'text-gothic',
    props.color === ColorsEnum.Green && 'text-green',
    props.color === ColorsEnum.Red && 'text-red',
    props.isUppercase && 'uppercase',
    props.className,
  );

  if (props.children == null) return null;
  return <div className={className}>{props.children}</div>;
};
